import { getGlosbeTransferState } from '@app/services/transferState-service';
import { writable } from 'svelte/store';
import { RecentlyViewedConvert } from './RecentlyViewed.model';
const EMPTY_RECENTLY_VIEWED = { items: [], user: { loggedIn: false, uid: -1 } };
const RECENTLY_VIEWED_LOCAL_STORAGE_KEY = "rv";
const MAX_RECENTLY_USED = 1000;
export const recentlyViewedTranslations = writable(EMPTY_RECENTLY_VIEWED);
let initialized = false;
recentlyViewedTranslations.subscribe(newVal => {
    if (initialized) {
        setTimeout(() => storeRecentlyUsedInLocalStorage(newVal));
    }
});
function storeRecentlyUsedInLocalStorage(recentlyViewed) {
    if (window.localStorage) {
        window.localStorage.setItem(RECENTLY_VIEWED_LOCAL_STORAGE_KEY, RecentlyViewedConvert.recentlyViewedToJson(recentlyViewed));
    }
}
function loadRecentlyViewedFromLocalStorage() {
    const transferState = getGlosbeTransferState();
    let recentlyViewedFromLocal = EMPTY_RECENTLY_VIEWED;
    let resetRecentlyViewedState = false;
    try {
        recentlyViewedFromLocal = RecentlyViewedConvert.toRecentlyViewed(window.localStorage.getItem(RECENTLY_VIEWED_LOCAL_STORAGE_KEY) || '{"items": []}');
        const isRecentForDifferentUser = !transferState.auth || !recentlyViewedFromLocal.user || transferState.auth.uid !== recentlyViewedFromLocal.user.uid;
        if (isRecentForDifferentUser) {
            resetRecentlyViewedState = true;
        }
    }
    catch (e) {
        console.warn("Can't read recently viewed from local store, will reset", e);
        // reset recently viewed to proper state
        resetRecentlyViewedState = true;
    }
    if (resetRecentlyViewedState) {
        recentlyViewedFromLocal = EMPTY_RECENTLY_VIEWED;
        if (transferState.auth) {
            recentlyViewedFromLocal.user.uid = transferState.auth.uid;
            recentlyViewedFromLocal.user.loggedIn = transferState.auth.loggedIn;
        }
        storeRecentlyUsedInLocalStorage(recentlyViewedFromLocal);
    }
    recentlyViewedTranslations.set(recentlyViewedFromLocal);
}
function addCurrentPhraseTranslationPageToRecentlyViewed() {
    const glosbeTransferState = getGlosbeTransferState();
    if (!glosbeTransferState.phrase) {
        // we aren't on phrase translation page, do nothing
        return;
    }
    const recentlyViewedEntry = {
        l1Name: glosbeTransferState.dictionary.l1.name,
        l1Code: glosbeTransferState.dictionary.l1.code,
        l2Name: glosbeTransferState.dictionary.l2.name,
        l2Code: glosbeTransferState.dictionary.l2.code,
        phrase: glosbeTransferState.phrase,
        timestamp: Date.now()
    };
    recentlyViewedTranslations.update(({ items, user }) => {
        const newItems = [recentlyViewedEntry,
            ...items.filter(item => item.l1Code !== recentlyViewedEntry.l1Code || item.l2Code !== recentlyViewedEntry.l2Code || item.phrase !== recentlyViewedEntry.phrase)
        ].slice(0, MAX_RECENTLY_USED);
        return { items: newItems, user };
    });
}
export function initRecentlyUsedStore() {
    loadRecentlyViewedFromLocalStorage();
    initialized = true;
    addCurrentPhraseTranslationPageToRecentlyViewed();
}
